import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExtensionService {

  commonPath: string = '/assets/images/extension/';
  public validExtensions: { [key: string]: string } = {
    '2013t2': '2013t2.svg',
    '2014t2': '2014t2.svg',
    '2015t2': '2015t2.svg',
    '2016t2': '2016t2.svg',
    '2017t2': '2017t2.svg',
    '2018t2': '2018t2.svg',
    '2019t2': '2019t2.svg',
    '2020t2': '2020t2.svg',
    '2021t2': '2021t2.svg',
    '2022t2': '2022t2.svg',
    '2023t2': '2023t2.svg',
    '2024t2': '2024t2.svg',
    '2025t2': '2025t2.svg',
    '112': '112.svg',
    '113': '113.svg',
    '114': '114.svg',
    '115': '115.svg',
    '116': '116.svg',
    '117': '117.svg',
    '118': '118.svg',
    '119': '119.svg',
    '120': '120.svg',
    '121': '121.svg',
    '122': '122.svg',
    '123': '123.svg',
    '124': '124.svg',
    '125': '125.svg',
    '213': '213.svg',
    '214': '214.svg',
    '215': '215.svg',
    '216': '216.svg',
    '217': '217.svg',
    '218': '218.svg',
    '219': '219.svg',
    '220': '220.svg',
    '221': '221.svg',
    '222': '222.svg',
    '223': '223.svg',
    '224': '224.svg',
    '225': '225.svg',
    '312': '312.svg',
    '313': '313.svg',
    '314': '314.svg',
    '315': '315.svg',
    '316': '316.svg',
    '317': '317.svg',
    '318': '318.svg',
    '319': '319.svg',
    '320': '320.svg',
    '321': '321.svg',
    '322': '322.svg',
    '323': '323.svg',
    '324': '324.svg',
    '325': '325.svg',
    'ayt': 'ayt.svg', 'byt': 'byt.svg', '00c': '00c.svg', '13t': '13t.svg',
    'c00': 'c00.svg',
    'cchlck': 'cchlck.svg',
    'clt': 'clt.svg',
    'cmf': 'cmf.svg',
    'd00': 'd00.svg',
    'h00': 'h00.svg',
    'iyt': 'iyt.svg',
    'm00': 'm00.svg',
    'n00': 'n00.svg',
    'ryt': 'ryt.svg',
    't12': 't12.svg',
    't13': 't13.svg',
    't14': 't14.svg',
    't15': 't15.svg',
    't16': 't16.svg',
    't17': 't17.svg',
    't18': 't18.svg',
    't19': 't19.svg',
    't20': 't20.svg', 't21': 't21.svg', 't22': 't22.svg',  't23': 't23.svg', 't24': 't24.svg', 'tax_cycle': 'tax_cycle.svg', 'uyt': 'uyt.svg',
    '%yt': 'lyt.svg', 'lyt': 'lyt.svg', 'pyt': 'pyt.svg', 'tax_prep': 'tax_prep.svg'
  };
  private readonly basePath = '/assets/images/extension/';
  private readonly extensionMap: { [key: string]: string } = {
    'excel': 'excel.svg',
    'csv': 'csv.png',
    'xlsx': 'xlsx.svg',
    'xls': 'xls.png',
    'xlsm': 'xlsm.svg',
    'xlt': 'xlt.png',
    'xltx': 'xltx.png',
    'xltm': 'xltm.png',
    'xla': 'xla.png',
    'xlam': 'xlam.png',
    'pptx': 'pptx.svg',
    'doc': 'doc.png',
    'docx': 'docx.svg',
    'ppt': 'ppt.png',
    'pot': 'pot.png',
    'potx': 'potx.svg',
    'ppsx': 'ppsx.svg',
    'pdf' : 'pdf.svg',
    'jpg' : 'jpg.svg',
    'jpeg' : 'jpg.svg'

  };
  private readonly defaultIcon = 'xlsx.svg';
  private readonly attachableFileTypes: Array<{ extension: string, mimeType: string }> = [
    { extension: 'ai', mimeType: 'application/postscript' },
    { extension: 'bmp', mimeType: 'image/bmp' },
    { extension: 'csv', mimeType: 'text/csv' },
    { extension: 'doc', mimeType: 'application/msword' },
    { extension: 'docx', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
    { extension: 'eps', mimeType: 'application/postscript' },
    { extension: 'eml', mimeType: 'message/rfc822' },
    { extension: 'gif', mimeType: 'image/gif' },
    { extension: 'jpeg', mimeType: 'image/jpeg' },
    { extension: 'jpg', mimeType: 'image/jpeg' },
    { extension: 'key', mimeType: 'application/x-iwork-keynote-sffkey' },
    { extension: 'msg', mimeType: 'application/vnd.ms-outlook' },
    { extension: 'numbers', mimeType: 'application/x-iwork-numbers-sffnumbers' },
    { extension: 'odt', mimeType: 'application/vnd.oasis.opendocument.text' },
    { extension: 'ods', mimeType: 'application/vnd.oasis.opendocument.spreadsheet' },
    { extension: 'pages', mimeType: 'application/x-iwork-pages-sffpages' },
    { extension: 'pdf', mimeType: 'application/pdf' },
    { extension: 'png', mimeType: 'image/png' },
    { extension: 'ppt', mimeType: 'application/vnd.ms-powerpoint' },
    { extension: 'pptx', mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' },
    { extension: 'rtf', mimeType: 'text/rtf' },
    { extension: 'svg', mimeType: 'image/svg+xml' },
    { extension: 'tif', mimeType: 'image/tiff' },
    { extension: 'tiff', mimeType: 'image/tiff' },
    { extension: 'txt', mimeType: 'text/plain' },
    { extension: 'xls', mimeType: 'application/vnd.ms-excel' },
    { extension: 'xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    { extension: 'xml', mimeType: 'text/xml' },
    { extension: 'zip', mimeType: 'application/zip' },
  ];

  private readonly previewableExtensions = new Set([
    'pdf', 'jpg', 'jpeg', 'png', 'gif', 'txt', 'xml', 'json', 'svg', 'bmp'
  ]);

  getExtensionPath(file) {
    const extension = (file?.extension ? file?.extension : this.getFileExtension(file)).toLocaleLowerCase();
    // Check if the extension is in the validExtensions array
    if (this.validExtensions.hasOwnProperty(extension)) {
      return this.commonPath + this.validExtensions[extension];
    }
    if (extension?.length === 6 && extension.startsWith('20') && extension.endsWith('t2')) {
      return this.commonPath + 'tax_cycle.svg';
    } else if (extension?.length === 3) {
      switch (extension[0]) {
        case '1': return this.commonPath + 'tax_prep.svg';
        case '2': return this.commonPath + 'tax_prep.svg';
        case '3': return this.commonPath + 'tax_prep.svg';
        case 't': return this.commonPath + 'tax_prep.svg';
        default: return this.commonPath + 'tax_prep.svg';
      }
    }
    return this.commonPath + 'tax_prep.svg';

  }

  getFileExtension(file): string {
    const fileName = file?.originalfilename || file?.filename || file?.docname;
    const parts = fileName?.split('.');
    return parts?.length > 1 ? parts.pop() : '';
  }

  getFileLocation(extension: string): string {
    const fileName = this.extensionMap[extension.toLowerCase()] || this.defaultIcon;
    return `${this.basePath}${fileName}`;
  }

  getExtensionByMimeType(mimeType: string): string | null {
    const found = this.attachableFileTypes.find(f =>
      f.mimeType.toLowerCase() === mimeType.toLowerCase());
    return found?.extension ?? null;
  }

  isPreviewableFile(extension: string): boolean {
    return this.previewableExtensions.has(extension.toLowerCase());
  }
  
  public adjustBlobTypeBasedOnExtension(blob: Blob, extension: string): Blob {
    const ext = extension.toLowerCase();
  
    // If the Blob has a valid MIME type, use it directly
    if (blob.type && blob.type !== 'text/xml') {
      return blob;
    }
  
    // Fallback mapping for known file extensions
    const mimeTypeMap: Record<string, string> = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      tiff: 'image/tiff',
      txt: 'text/plain',
      xml: 'text/xml',
      json: 'application/json',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      csv: 'text/csv'
    };
  
    const inferredType = mimeTypeMap[ext] || 'application/octet-stream';
  
    return new Blob([blob], { type: inferredType });
  }
  
}
